const Footer = () => {
  return (
    <div className="h-12 bg-white border-t flex items-center justify-center text-sm text-gray-500 mt-6">
      Designed and Developed By:
      <span className="text-blue-500 ml-1">
        VRSamadhan Tech
      </span>
    </div>
  );
};

export default Footer;